import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const mediaUrl = (url) => (url ? (url.startsWith("http") ? url : `${BACKEND_URL}${url}`) : null);
